export default __webpack_public_path__ + "static/media/activity-refueling.97e8a943.svg";